<template>
  <h-form-page :title="h_i18n('5fb3e02746e497ae961651a90b7e06bc')" @inspection-update="inspectionUpdate">
    <form-header :title="h_i18n('8995232b8db82519b843a940a48a5829')" title-width="5">
      <template #title>
        <h-p align="left" :title="h_i18n('4850ea222f13bd23bec1cdace19cb633')" style="margin-left: 10px">{{ $route.query.testNo }}</h-p>
      </template>
      <template #body>
        <tr>
          <report-td :title="h_i18n('1f73e72960b0286b70d7226116671454')" colspan="3:5">{{ mainData.consignDepart }}</report-td>
          <report-td :title="h_i18n('33418712f3f79338496222d07a678655')" colspan="3:5">{{ mainData.patternName }}</report-td>
          <report-td :title="h_i18n('bec1a78c61977443ce70c7b6ff218b33')" colspan="3:5">{{ mainData.testNo }}</report-td>
        </tr>
        <tr>
          <report-td :title="h_i18n('f4aadbe7c1febb0b5cd8c1a9164319e3')" colspan="3:5">{{ mainData.testPropertyName }}</report-td>
          <report-td :title="h_i18n('5b44a189ef63ff82342d25798df71213')" colspan="3:5">{{ mainData.supplyName }}</report-td>
          <report-td :title="h_i18n('0036859e2c8488ebd6cc5f8103bf8220')" colspan="3:5">{{ mainData.patternNo }}</report-td>
        </tr>
      </template>
    </form-header>
    <form-area :title="[h_i18n('8995232b8db82519b843a940a48a5829'),h_i18n('f26225bde6a250894a04db4c53ea03d0')]">
      <template #default="{value}">
        <div v-if="value===h_i18n('8995232b8db82519b843a940a48a5829')">
          <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" v-loading="tableListLoading" border :data="dataTableList" size="small">
            <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')" width="40"></el-table-column>
            <el-table-column prop="itemName" :label="h_i18n('222c0f1a6341c9df01ca58fc982db93b')" min-width="100"></el-table-column>
            <el-table-column prop="testResult" :label="h_i18n('5682a384872f6fc6f1cd8968b09876cf')" min-width="80"></el-table-column>
            <el-table-column prop="singleDeterminant" :label="h_i18n('4158228943415a8cc85084d68ef18802')" min-width="80">
              <template #default="{row}">
                <div class="dangerColor" v-if="row.singleDeterminant==='F'">{{ h_i18n('6e5a122013138ad189517d5d0a1c0891') }}</div>
                <!-- <div class="successColor" v-else-if="row.singleDeterminant==='P'">合格</div>
                <div v-else>{{ row.singleDeterminant }}</div> -->
              </template>
            </el-table-column>
            <el-table-column prop="testType" :label="h_i18n('2432b57515b3627faddccb1dd1df206e')" min-width="200"></el-table-column>
          </el-table>
        </div>
        <form-body v-if="value===h_i18n('f26225bde6a250894a04db4c53ea03d0')">
          <tr>
            <report-td :title="h_i18n('3f206473f0425a273a84834a89fb9ff2')" colspan="3:21">{{ mainData.testOtherAsk }}</report-td>
          </tr>
        </form-body>
      </template>
      <template #footer>
        <h-button-group align="center">
          <h-button type="primary" size="big" @click="print">{{ h_i18n('e414473c886072e393710563f201d7f3') }}</h-button>
          <h-button type="default" size="big" @click="$router.back()">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
        </h-button-group>
      </template>
    </form-area>


  </h-form-page>
</template>






<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import {DataFormatter, Export, Loading, LoadingButton, Request, Time, Trim} from "../../../Decorator/vue2-decorator";

export default {
  name: "PPAPApplicabilityEvaluationDetail",
  data() {
    return {
      beforeData: {},
      mainData: {},
      ppapAssess: {},
      tableListLoading: false,
      dataTableList: [],
    }
  },
  mounted() {
    this.searchValue()
  },
  methods: {
    h_i18n,
    print() {
      const _1 = () => {
        document.querySelector(".haier-title-lable").style.display = "flex"
        document.querySelector(".h-form-area-footer").style.display = "flex"

        window.removeEventListener("beforeinput", _1)
        window.removeEventListener("afterprint", _1)
      }
      document.querySelector(".haier-title-lable").style.display = "none"
      document.querySelector(".h-form-area-footer").style.display = "none"
      window.addEventListener("beforeinput", _1)
      window.addEventListener("afterprint", _1)
      window.print()
    },
    inspectionUpdate() {
      this.postThisPageHeight()
    },
    typeToValue(value) {
      return value ? value : "-"
    },
    mainDataType(value) {
      return value ? value === "Y" ? "是" : "否" : "-"
    },
    formDate(val, q = 3) {
      return val ? this.time(val, q) : "-"
    },
    //assessId
    @Request("vmiServiceBasic")
        @Loading(h_i18n('1b528fb0e70183fce80e05c948729502'))
    searchValue() {
      return request({
        method: "GET",
        url: "/testTaskReport/selectTestTaskReportListByTestNo?testNo=" + this.$route.query.testNo,
      }).then(res => {
        if (res.data.code === "200") {
          this.mainData = res.data.data
          this.dataTableList = res.data.data.detailVOList.filter(item=>{
            return item.singleDeterminant == 'F'
          })
          try {
            delete this.mainData.detailVOList
          } catch (e) {
            console.log(e)
          }
          setTimeout(()=>{
            this.inspectionUpdate()
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.h-hwork-form-header {
  padding: 0;
}

:deep(.haier-table-header--right) {
  position: unset !important;
}

.haier-td {
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  text-align: left;
  padding: 4px 10px;
  font-size: 14px;
  height: 35px;
  color: #666;
}

.haier-cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.haier-text-right {
  text-align: right;
}

.haier-cell:hover {
  white-space: normal;
  word-break: break-all;
}

.el-table {
  :deep(.cell) {
    white-space: unset;
  }
}
@page {
  size: auto;

  margin: auto 0;
}
</style>